import { useNavigate, useParams } from 'react-router-dom'
import { useResetTradeBuilder } from 'state/store'

import {
  FullWidthBar,
  LeftSideBar,
  Navigation,
  Space,
  Typography,
  UserMenuTopBar
} from '../../components/core-v2'
import Icon from '../../components/core-v2/atoms/Icon'
import LinkIcon from '../../components/core-v2/molecules/linkIcon'
import { PATH } from '../../const'
import { useUser } from '../../utilities/hooks/useUser'
import { Builder } from './modules/00-builder'
import { useAppSelector } from './store/hooks'
import { getUserRoles, getUserType } from './util/user'

function Header() {
  const accountName = useAppSelector(state => state.terms?.terms?.accountName)
  const navigate = useNavigate()

  return (
    <FullWidthBar>
      <Typography className="mr-4" variant="sh3">
        {accountName || 'New Trade'}
      </Typography>
      <LinkIcon
        data-testid="back-to-new-trades-button"
        disabled={false}
        icon={<Icon name="chevronLeft" size="small" />}
        iconPosition="left"
        text="Back to all new trades"
        onClick={() => navigate(PATH.trades)}
      />
    </FullWidthBar>
  )
}

export function TradeBuilder() {
  const { data: user } = useUser()
  const userType = getUserType(user)
  useResetTradeBuilder()

  return (
    <LeftSideBar
      leftElement={<Navigation />}
      mainElement={
        <>
          <Header />
          <Space mt={4}>
            <Builder userName={user.userName} userRoles={getUserRoles(user)} userType={userType} />
          </Space>
        </>
      }
      topBarElement={<UserMenuTopBar />}
    />
  )
}

export function TradeBuilderExistingAccount() {
  const { accountId } = useParams()
  const { data: user } = useUser()
  const userType = getUserType(user)
  useResetTradeBuilder()

  return (
    <LeftSideBar
      leftElement={<Navigation />}
      mainElement={
        <>
          <Header />
          <Space mt={4}>
            <Builder
              accountId={accountId}
              userName={user.userName}
              userRoles={getUserRoles(user)}
              userType={userType}
            />
          </Space>
        </>
      }
      topBarElement={<UserMenuTopBar />}
    />
  )
}
